import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { Recomendation } from '../../models/case';

export interface ParticipantTypesResponse {
  main: string[];
  detail: string[];
}

@Injectable({
  providedIn: 'root'
})
export class CaseService {
  api_url = environment.apiUrl;
  query: string;
  cashed_case: Observable<any>;

  constructor(private http: HttpClient) {

  }

  clearCache() {
    this.query = null;
    this.cashed_case = null;
  }

  getCasesList(params?: any) {
    return this.http.get(this.api_url + "/cases", { params: params });
  }

  getCase(uuid: string) {
    if (!this.cashed_case) {
      this.cashed_case = this.http.get(this.api_url + "/cases/" + uuid).pipe(
        shareReplay()
      )
    }
    return this.cashed_case;
  }

  getPossibleStatusList() {
    return this.http.get<any[]>(this.api_url + "/cases/statuses");
  }

  getParticipantTypes() {
    return this.http.get<ParticipantTypesResponse>(this.api_url + "/cases/participant-types");
  }

  getExportResultFile(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' });
  }

  getRecomendations(uuid: string): Observable<Recomendation[]> {
    let url = `${this.api_url}/recomendations/`
    return this.http.get<Recomendation[]>(url, { params: { uuid: uuid } });
  }

  public deleteCase(uuid: string): Observable<any> {
    return this.http.delete(`${this.api_url}/cases/${uuid}`);
  }

}
